import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import axios from "axios";
import { base_url } from "../../context/Authcontext";
import { AuthContext } from "../../context/Authcontext";
import React, { useMemo, useEffect, useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ChevronDown } from "lucide-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faImage, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../context/ThemeContext";
import MarqueeBottom from "../components/MarqueeBottom";
import { FaUniversity } from "react-icons/fa";

const SportsBets = () => {
  const { themeColors } = useTheme();
  const [isSidebar, setSidebar] = useState(true);
  const [data, setData] = useState([]);
  const [statement, setStatement] = useState([]);
  const base_url = process.env.REACT_APP_API_URL;
  const location = useLocation();

  const [active, setActive] = useState(location.state?.activeTab || 0);

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActive(location.state.activeTab);
    }
  }, [location.state?.activeTab]); // Watch for changes in state

  useEffect(() => {
    const sportData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/sportData", {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        // console.log("Response data:", response.data);
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching sport data:", error);
      }
    };

    const accountStatement = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/webapi/accountStatement",
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("Response baba:", response.data);

        // Store the entire response data to access all arrays
        setStatement(response.data);
      } catch (error) {
        console.error("Error fetching account statement:", error);
      }
    };

    const history = async () => {
      const gameToken = localStorage.getItem("game_token");
      if (!gameToken) {
        console.warn("Missing game_token, skipping history call.");
        return;
      }

      try {
        const response = await axios.get(
          base_url + "/api/webapi/casinoHistory",
          {
            params: {
              gameToken,
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
      } catch (err) {
        console.log(err);
      }

      // console.log('history',response);
    };

    history();
    accountStatement();
    sportData();
  }, []);

  return (
    <>
      <div style={{ background: themeColors["--dark-theme-color-navbar"] }}>
        <Header
          isSidebar={isSidebar}
          setSidebar={setSidebar}
          show={showCanvas}
          handleShow={handleCanvasShow}
          handleClose={handleCanvasClose}
        />
        <div className="d-flex gap-2">
          <div className="d-none d-md-flex d-xl-flex">
            <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
          </div>
          <div
            _ngcontent-tgc-c107=""
            className="content sportMargin"
            style={{
              width: isLargeScreen ? "1143px" : "100%",
              marginLeft: isLargeScreen ? "0px" : "0px",
            }}
          >
            <reports-top-nav _nghost-tgc-c127="">
              <ul
                _ngcontent-tgc-c127=""
                className="popular-tab custom-scrollbar pt-3 pb-2 d-none mt-lg-0 mt-5 px-2"
              >
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 3 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(3)}
                >
                  {" "}
                  Account Statement{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 0 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(0)}
                >
                  {" "}
                  Current Bet{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 1 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(1)}
                >
                  {" "}
                  Casino Bets{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 2 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(2)}
                >
                  {" "}
                  Fancy Bets{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 4 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(4)}
                >
                  {" "}
                  Profit & Loss{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 5 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(5)}
                >
                  {" "}
                  Change Password{" "}
                </li>
                <li
                  _ngcontent-tgc-c127=""
                  routerlinkactive="active"
                  className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                    active === 6 ? "active" : ""
                  }`}
                  tabIndex="0"
                  onClick={() => setActive(6)}
                >
                  {" "}
                  Result{" "}
                </li>
              </ul>
            </reports-top-nav>
            {active === 0 && <SportsBetsHistory data={data} />}
            {active === 1 && <CasinoBetsHistory />}
            {active === 2 && <FancyBetsHistory />}

            {active === 3 && <Accountstatement data={statement} />}
            {active === 4 && <ProfitLoss data={data} />}
            {active === 5 && <ChangePassword />}
            {active === 6 && <Result />}
          </div>
        </div>
        <MarqueeBottom onMenuClick={handleCanvasShow} />
      </div>
    </>
  );
};

const SportsBetsHistory = ({ data }) => {
  const [filterType, setFilterType] = React.useState("SETTLED");
  const [startDate, setStartDate] = React.useState("");
  const [startTime, setStartTime] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const { themeColors } = useTheme();
  const [filteredData, setFilteredData] = React.useState([]);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  // Initialize with the original data
  React.useEffect(() => {
    const sportData = data && data.sportData ? data.sportData : [];
    setFilteredData(sportData);
  }, [data]);

  // Handle form submission
  const handleLoadReport = (e) => {
    e.preventDefault();

    const sportData = data && data.sportData ? data.sportData : [];
    // console.log(sportData,"sportData Ansh")
    // Filter the data based on dates
    const filtered = sportData.filter((item) => {
      const itemDate = new Date(item.time);

      // Create date objects for comparison
      let startDateTime = null;
      let endDateTime = null;

      if (startDate) {
        startDateTime = new Date(startDate);
        if (startTime) {
          const [hours, minutes] = startTime.split(":");
          startDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
        } else {
          startDateTime.setHours(0, 0, 0);
        }
      }

      if (endDate) {
        endDateTime = new Date(endDate);
        if (endTime) {
          const [hours, minutes] = endTime.split(":");
          endDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 59);
        } else {
          endDateTime.setHours(23, 59, 59);
        }
      }

      // Apply date filters
      let passesFilter = true;

      if (startDateTime && itemDate < startDateTime) {
        passesFilter = false;
      }

      if (endDateTime && itemDate > endDateTime) {
        passesFilter = false;
      }

      // Apply filter type if needed
      if (filterType && item.status !== filterType) {
        // Assuming there's a status field in your data
        // If not, you'll need to adjust this condition
        passesFilter = false;
      }

      return passesFilter;
    });
    console.log(filtered, "filtered");

    setFilteredData(filtered);
  };

  return (
    <>
      <div className="mt-0">
        <div
          className="py-2 px-3"
          style={{ backgroundColor: "#000" }}
        >
          <h4 className="my-1">Sports Bet</h4>
        </div>
        <form
          className="form-container"
          style={{
            display: "flex",
            backgroundColor: themeColors["--dark-theme-color-navbar"],
            padding: "10px 0px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Filter Type Dropdown */}
          <div style={{ flex: 3 }}>
            <p
              style={{
                color: themeColors["--text-table"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              Filter Type
            </p>
            <select
              style={{
                width: isLargeScreen ? "210px" : "100%",
                backgroundColor: themeColors["--dark-theme-color"],
                color: themeColors["--text-table"],
                border: "1px solid var(--table-border)",
                padding: "10px",
                borderRadius: "4px",
                appearance: "auto",
              }}
            >
              <option>Sports</option>
              {/* <option>MATCHED</option>
              <option>CANCEL</option>
              <option>VOIDED</option>
              <option>LAPSED</option>
              <option>UN-MATCHED</option> */}
            </select>
          </div>

          {/* Start Date & Time */}
          {/* <div style={{ flex: 3.5 }}>
            <p style={{ color: themeColors['--dark-theme-white-color'], fontSize: '14px', marginBottom: '8px' }}>Start Date & Time:</p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ position: 'relative', flex: 1 }}>
                <input
                  type="text"
                  defaultValue="04-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{ width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: '1px solid #128aa2', padding: '10px', borderRadius: '4px', paddingRight: '30px' }}
                />
                <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z" stroke="white" strokeWidth="1.5" />
                    <path d="M11 1v3M5 1v3M2 6h12" stroke="white" strokeWidth="1.5" />
                  </svg>
                </span>
              </div>
              <div style={{ position: 'relative', flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10:48:21"
                  style={{ width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: '1px solid #128aa2', padding: '10px', borderRadius: '4px', paddingRight: '30px' }}
                />
                <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="6.5" stroke="white" strokeWidth="1.5" />
                    <path d="M8 4v4l3 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </span>
              </div>
            </div>
          </div> */}

          {/* End Date & Time */}
          {/* <div style={{ flex: 3.5 }}>
            <p style={{ color: themeColors['--dark-theme-white-color'], fontSize: '14px', marginBottom: '8px' }}>End Date & Time:</p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ position: 'relative', flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{ width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: '1px solid #128aa2', padding: '10px', borderRadius: '4px', paddingRight: '30px' }}
                />
                <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z" stroke="white" strokeWidth="1.5" />
                    <path d="M11 1v3M5 1v3M2 6h12" stroke="white" strokeWidth="1.5" />
                  </svg>
                </span>
              </div>
              <div style={{ position: 'relative', flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10:48:21"
                  style={{ width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: '1px solid #128aa2', padding: '10px', borderRadius: '4px', paddingRight: '30px' }}
                />
                <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="6.5" stroke="white" strokeWidth="1.5" />
                    <path d="M8 4v4l3 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </span>
              </div>
            </div>
          </div> */}

          {/* Load Report Button */}
          {/* <div style={{ flex: 2, marginTop: "28px" }}>
            <button style={{ width: '100%', background: themeColors['--dark-theme-card-bg'], color: '#000000', border: 'none', borderRadius: '4px', padding: '10px', fontWeight: 'bold', cursor: 'pointer' }}>
              Load Report
            </button>
          </div> */}
        </form>
      </div>
      <table className="  table-responsive-sm table-responsive-md w-100">
        <thead
          style={{
            backgroundColor: isLargeScreen
              ? "#000"
              : "#000",
          }}
        >
          <tr className="p-2  bb">
            <th className="text-center text-nowrap bb text-white">Tournament Name</th>
            <th className="text-center text-nowrap bb text-white">Market Name</th>
            <th className="text-center text-nowrap bb text-white">Runner Name</th>
            <th className="text-center text-nowrap bb text-white">Side</th>
            <th className="text-center text-nowrap bb text-white">Odds</th>
            <th className="text-center text-nowrap bb text-white">Price</th>
            <th className="text-center text-nowrap bb text-white">p/f</th>
            <th className="text-center text-nowrap bb text-white">status</th>

            <th className="text-center text-nowrap bb">Placed Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredData && filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <tr
                key={index}
                className="border"
                style={{
                  background:
                    item.side === "Back"
                      ? "linear-gradient(180deg, #f59dc2, #f5e9ee)"
                      : "linear-gradient(180deg, #84c2f1, #d9efff)",
                }}
              >
                <td className="text-start p-2 text-white bb">
                  {item.competitionName}
                </td>
                <td className="text-center text-white bb">{item.eventName}</td>
                <td className="text-center text-white bb">{item.runnerName}</td>
                <td className="text-center text-white bb">{item.side}</td>
                <td className="text-center text-white bb">{item.betprice}</td>

                <td className="text-center text-white bb">
                  {item.deducted_amount}
                </td>
                <td className="text-center text-white bb">
                  {item.status === 1
                    ? item.profit
                    : item.status === 2
                    ? item.deducted_amount
                    : "-"}
                </td>
                <td className="text-center text-white  bb">
                  <span
                    style={{
                      backgroundColor:
                        item.status === 1
                          ? "rgb(3, 187, 22)"
                          : item.status === 2
                          ? "rgba(255, 0, 0, 1)"
                          : "rgba(255, 193, 7, 1)",
                      fontWeight: "700",
                      padding: "3px",
                      borderRadius: "3px",
                    }}
                  >
                    {item.status === 1
                      ? "Win"
                      : item.status === 2
                      ? "Loss"
                      : item.status === 4
                      ? "Bet Deleted"
                      : "Pending"}
                  </span>
                </td>

                <td className="text-center text-white bb">
                  {new Date(item.time).toLocaleString()}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="8"
                className="text-center text-dark"
                style={{ color: themeColors["--dark-theme-color-navbar"] }}
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const CasinoBetsHistory = () => {
  const { themeColors } = useTheme();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const history1 = async () => {
      const gameToken = localStorage.getItem("game_token");
      if (!gameToken) {
        console.warn("Missing game_token, skipping history call.");
        return;
      }

      try {
        const response = await axios.get(
          base_url + "/api/webapi/casinoHistory",
          {
            params: {
              gameToken,
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
      } catch (err) {
        console.log(err);
      }

      // console.log('history',response);
    };

    const history = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/webapi/myCasinoHistory",
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('history',response);
        const data = response?.data.histry;

        setHistory(data);
      } catch (err) {
        console.log(err);
      }
    };

    history1();
    history();
  }, []);

  return (
    <>
      <div>
           <div
          className="py-2 px-3"
          style={{ backgroundColor: "#000" }}
        >
          <h4 className="my-1">Casino Bet</h4>  
        </div>


      </div>
      <table className=" w-100 table-responsive-sm">
        <thead
          style={{
            backgroundColor:"#000",
          }}
        >
          <tr className="p-2  bb">
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Game Code
            </th>
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Game Name
            </th>
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Round ID
            </th>
        
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Price
            </th>
                <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Profit/Loss
            </th>
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Status
            </th>
            {/* <th className="text-center text-nowrap bb" style={{color: themeColors['--dark-theme-color-navbar']}}>Size</th> */}
            <th
              className=" text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Date
            </th>
          </tr>
        </thead>
        <tbody>
          {history?.length > 0 ? (
            history?.map((hist, index) => {
              return (
                <tr
                  key={index}
                  className="border"
                  style={{
                    background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                  }}
                >
                  <td className="bb">{hist?.gameId}</td>
                  <td className="bb">{hist?.gameCategory}</td>
                  <td className="text-center bb">{hist?.playerGameRoundId}</td>
               
                  <td className="text-center bb">{hist?.amount}</td>
                 <td
  className={`text-center ${
    hist?.status === "lose" ? "text-red" : "text-green"
  }`}
>
  {hist?.status === "lose" ? hist.amount : hist.profit}
</td>

                  <td className="text-center bb">
  <span
    className="rounded px-2"
    style={{
      background:
        hist?.status === "lose"
          ? "rgb(255,0,0)"
          : hist?.status === "pending"
          ? "orange"
          : "rgb(3,187,22)",
      color: "#fff",
    }}
  >
    {hist?.status === "pending" ? "Rollback" : hist?.status}
  </span>
</td>
                  <td className="text-center bb">{hist?.time}</td>
                </tr>
              );
            })
          ) : (
            <div style={{ color: themeColors["--dark-theme-white-color"] }}>
              No Data found for your game.
            </div>
          )}
        </tbody>
      </table>
    </>
  );
};

const FancyBetsHistory = () => {
  const { themeColors } = useTheme();
  const [fancyDataHistory, setfancyDataHistory] = useState([]);

  useEffect(() => {
    const sportData = async () => {
      // console.log("Devansh is devansh ")
      try {
        const response = await axios.get(
          base_url + "/api/webapi/getFancyDataHistory",
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("Response data: of fancy", response.data.history);
        setfancyDataHistory(response?.data?.history);
      } catch (error) {
        console.error("Error fetching sport data:", error);
      }
    };
    sportData();
  }, []);

  return (
    <>
      <div className="mt-3 ">
        <form
          className="form-container"
          style={{
            display: "flex",
            backgroundColor: themeColors["--dark-theme-color-navbar"],
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Filter Type Dropdown */}
          <div style={{ flex: 3 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              Filter Type
            </p>
            <select
              style={{
                width: "100%",
                backgroundColor: themeColors["--dark-theme-color"],
                color: themeColors["--dark-theme-white-color"],
                border: "1px solid #128aa2",
                padding: "10px",
                borderRadius: "4px",
                appearance: "auto",
              }}
            >
              <option>SETTLED</option>
              <option>MATCHED</option>
              <option>CANCEL</option>
              <option>VOIDED</option>
              <option>LAPSED</option>
              <option>UN-MATCHED</option>
            </select>
          </div>

          {/* Start Date & Time */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              Start Date & Time:
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  defaultValue="04-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M11 1v3M5 1v3M2 6h12"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
              </div>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="6.5"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M8 4v4l3 2"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* End Date & Time */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              End Date & Time:
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M11 1v3M5 1v3M2 6h12"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
              </div>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="6.5"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M8 4v4l3 2"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              style={{
                width: "100%",
                background: themeColors["--dark-theme-card-bg"],
                color: themeColors["--dark-theme-white-color"],
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>
      <table className="table-responsive-sm table-responsive-md w-100 bg-black">
        <thead
          style={{
            backgroundColor: themeColors["--dark-theme-dark-blue-variant"],
          }}
        >
          <tr className="p-2  bb">
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Market ID
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Market Name
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Runner Name
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Side
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Price
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Size
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Placed Date
            </th>
          </tr>
        </thead>
        <tbody>
          {fancyDataHistory.map((item, index) => (
            <tr
              key={index}
              className="border"
              style={{
                background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                height: "40px",
              }}
            >
              <td className="text-center text-nowrap bb ml-2">
                {item.marketId}
              </td>
              <td className="text-center text-nowrap bb">
                <span>{item.competitionName}</span>
                <span> / </span>
                <span>{item.eventName}</span>
                <span> / </span>
                <span>{item.runnerName}</span>
                <span>
                  {" "}
                  / <strong>Result:</strong>{" "}
                </span>
                <span>{item.result ? item.result : "Pending"}</span>
              </td>

              <td className="text-center text-nowrap bb">{item.rate}</td>
              <td className="text-center text-nowrap bb">{item.side}</td>
              <td className="text-center text-nowrap bb">{item.betprice}</td>
              <td className="text-center text-nowrap bb">{item.value}</td>
              <td className="text-center text-nowrap bb">
                {new Date(item.time).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const Accountstatement = ({ data }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("all");
  const { themeColors } = useTheme();

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  console.log(data, "accountment");

  const handleImageClick = (imageUrl) => {
    if (!imageUrl) return;
    const fullImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${base_url}${imageUrl}`;
    setSelectedImage(fullImageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  function formatDateTime(timestamp) {
    if (!timestamp) return "N/A";
    try {
      if (timestamp.toString().length >= 13) {
        return new Date(parseInt(timestamp)).toLocaleString();
      }
      return new Date(timestamp).toLocaleString();
    } catch (e) {
      return timestamp.toString();
    }
  }

  function parseDate(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d)) return null;
    return new Date(d.toDateString()); // Strip time for exact date comparison
  }

  const parsedStartDate = parseDate(startDate);
  const parsedEndDate = parseDate(endDate);

  if (!data) return <div>Loading transaction data...</div>;

  const accountData = data.accountStmt || [];
  const sportsData = data.sportsData || [];
  const sportsFancyData = data.sportsFancyData || [];
  const withdrawalData = data.accwithdraw || [];
  const depositData = data.account || [];

  // Create combined transactions with proper mapping
  const combinedTransactions = [
    // Chips data from accountStmt
    ...accountData.map((item) => ({
      id_order: "Recharge Chips",
      name: "Recharge",
      type: item.type,
      amount: item.amount,
      balance: item.main_balance,
      time: item.time,
      today: item.today,
      status:
        item.status === 1
          ? "Approved"
          : item.status === 2
          ? "Rejected"
          : "Pending",
      remarks: item.remark,
      proof_image: item.proof_image,
      providerName: item.providerName || "",
      transactionType: "Chips", // Changed from "Deposit" to "Chips"
      RunningBalance: item.main_balance,
      dataSource: "accountStmt",
    })),
    // Chips data from sportsData
    ...sportsData.map((item) => ({
      id_order: "Sports Bet",
      name: item.runnerName,
      type: item.status === 1 ? "credit" : "debit",
      amount: item.status === 1 ? item.profit : item.betAmount,
      balance: item.balance,
      time: item.time,
      today: item.today,
      status:
        item.status === 1 ? "Win" : item.status === 2 ? "Lose" : "Pending",
      remarks: item.remark,
      proof_image: item.proof_image || "",
      providerName: item.providerName || "",
      transactionType: "Chips", // Changed from "Deposit" to "Chips"
      RunningBalance: item.main_balance,
      dataSource: "sportsData",
    })),
    // Chips data from sportsFancyData
    ...sportsFancyData.map((item) => ({
      id_order: "Fancy Bet",
      name: item.runnerName,
      type: item.status === 1 ? "credit" : "debit",
      amount: item.status === 1 ? item.profit : item.betAmount,
      balance: item.balance || 0,
      time: item.time,
      today: item.today || "",
      status:
        item.status === 1 ? "Win" : item.status === 2 ? "Lose" : "Pending",
      remarks: item.remark || "",
      proof_image: item.proof_image || "",
      providerName: item.providerName || "",
      transactionType: "Chips", // Changed from "Deposit" to "Chips"
      RunningBalance: item.main_balance || 0,
      dataSource: "sportsFancyData",
    })),
    // Deposit data from account
    ...depositData.map((item) => ({
      id_order: "Recharge Chips",
      name: "Recharge",
      type: "credit",
      amount: item.money,
      balance: item.remaining_bet,
      time: item.time,
      today: item.today,
      status:
        item.status === 1
          ? "Completed"
          : item.status === 2
          ? "Rejected"
          : "Pending",
      remarks: item.remarks,
      proof_image: item.proof_image,
      providerName: item.type || "",
      transactionType: "Deposit",
      RunningBalance: item.RunningBalance,
      dataSource: "account",
    })),
    // Withdrawal data from accwithdraw
    ...withdrawalData.map((item) => ({
      id_order: "Withdrawal Chips",
      name: "Withdrawal",
      type: "debit",
      amount: item.money,
      balance: "",
      remarks: item.remarks,
      status:
        item.status === 1
          ? "Completed"
          : item.status === 2
          ? "Rejected"
          : "Pending",
      proof_image: item.proof_image,
      time: item.time,
      today: item.today,
      providerName:
        !item.name_bank || item.name_bank === "undefined"
          ? "upi"
          : item.name_bank,
      transactionType: "Withdrawal",
      RunningBalance: item.RunningBalance,
      dataSource: "accwithdraw",
    })),
  ];

  function sortTransactions(transactions) {
    return transactions.sort((a, b) => {
      const todayA = a.today || "";
      const todayB = b.today || "";
      const timeA = a.time || "";
      const timeB = b.time || "";
      if (todayA !== todayB) return todayB.localeCompare(todayA);
      return timeB.localeCompare(timeA);
    });
  }

  // Apply filters
  const filteredTransactions = combinedTransactions.filter((item) => {
    // Filter by transaction type
    if (filterType !== "all") {
      const filterMapping = {
        deposit: "Deposit",
        withdraw: "Withdrawal",
        chips: "Chips",
      };

      if (item.transactionType !== filterMapping[filterType]) {
        return false;
      }
    }

    // Filter by date range
    if (parsedStartDate || parsedEndDate) {
      // Try to get date from 'today' field first, then from 'time' field
      let txnDateStr = item.today;
      if (!txnDateStr && item.time) {
        // Extract date part from time if it contains date
        txnDateStr = item.time.split(" ")[0];
      }

      const txnDate = parseDate(txnDateStr);
      if (!txnDate) return false;

      // Apply date range filter
      if (parsedStartDate && txnDate < parsedStartDate) return false;
      if (parsedEndDate && txnDate > parsedEndDate) return false;
    }

    return true;
  });

  const sortedTransactions = sortTransactions(filteredTransactions);

  console.log(sortedTransactions, "JJJJ");
  const thStyle = {
    padding: "10px",
    borderBottom: "1px solid #8888c8",
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #8888c8",
    whiteSpace: "nowrap",
  };
  const cellStyle = {
    flex: 1,
    padding: "10px",
    borderRight: "1px solid #444",
    textAlign: "center",
  };

  return (
    <>
      <div>
        {/* Header Section */}
        <div
          className="py-2 px-3"
          style={{ backgroundColor: "#000" }}
        >
          <h4 className="my-1">
            {" "}
            <span>
              <FaUniversity style={{ marginRight: "10px", color: "white" }} />
            </span>
            Account Statement
          </h4>
        </div>

        {/* Filter Section */}
        <div
          className="row filter-box"
          style={{
            borderRadius: "0 0 20px 20px",
            padding: isLargeScreen ? "10px 20px" : "0px 10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <div className="col-lg-3 col-6 mb-2">
            <label
              style={{
                margin: 0,
                color: themeColors["--dark-theme-white-color"],
              }}
            >
              Transaction Type
            </label>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value?.toLowerCase())}
              style={{
                padding: "9.8px 10px",
                borderRadius: "0px",
                width: "100%",
                border: "1px solid var(--table-border)",
                color: themeColors["--dark-theme-white-color"],
                outline: "none",
              }}
            >
              <option value="all">All</option>
              <option value="deposit">Deposit</option>
              <option value="withdraw">Withdrawal</option>
              <option value="chips">Chips</option>
            </select>
          </div>

          <div className="col-lg-3 col-6 mb-2 ps-0">
            <span style={{ color: themeColors["--dark-theme-white-color"] }}>
              From
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "",
                padding: "8px 10px",
                borderRadius: "0px",
                border: "1px solid var(--table-border)",
              }}
            >
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{
                  background: "transparent",
                  border: "none",
                  color: themeColors["--dark-theme-white-color"],
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div className="col-lg-3 col-12 mb-2">
            <span style={{ color: themeColors["--dark-theme-white-color"] }}>
              To
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 10px",
                borderRadius: "0px",
                border: "1px solid var(--table-border)",
              }}
            >
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{
                  background: "transparent",
                  border: "none",
                  color: themeColors["--dark-theme-white-color"],
                  width: "100%",
                }}
              />
            </div>
          </div>
        </div>

        {/* Table Section */}

        <div
          style={{
            borderRadius: "8px",
            overflow: "auto",
            marginTop: "10px",
          }}
        >
          <div
            className="sportcolor"
            style={{
              display: "flex",
              color: isLargeScreen
                ? themeColors["--text-table"]
                : themeColors["--text-secondary"],
              backgroundColor: isLargeScreen
                ? themeColors["--bg-table"]
                : themeColors["--bg-secondary"],
              border: "1px solid var(--table-border)",
            }}
          >
            {["TRANSACTION", "TYPE", "AMOUNT", "Details", "TIME"].map(
              (title, i) => (
                <div
                  key={i}
                  className="fw-bold text-nowrap"
                  style={{
                    flex: 1,
                    fontSize: "12px",
                    padding: "5px 10px",
                    borderRight:
                      i < 8 ? "1px solid var(--table-border)" : "none",
                    textAlign: "center",
                  }}
                >
                  {title}
                </div>
              )
            )}
          </div>

          {/* No Records Row */}
          {sortedTransactions.length > 0 ? (
            sortedTransactions.map((entry, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  background:
                    index % 2 === 0
                      ? "linear-gradient(180deg, #f59dc2, #f5e9ee)"
                      : "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                  color: themeColors["--dark-theme-white-color"],
                  fontSize: "13px",
                  borderTop: "1px solid #444",
                }}
              >
                <div style={cellStyle}>{entry.id_order || "N/A"}</div>
                <div style={cellStyle}>{entry.type}</div>
                <div style={cellStyle}>
                  {entry.type === "credit"
                    ? `+ ₹${entry.amount}`
                    : `- ₹${entry.amount}`}
                </div>
                {/* <div style={cellStyle}>
                  <span
                    style={{
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      background:
                        entry.status === "Approved" || entry.status === "Win"
                          ? "green"
                          : entry.status === "Rejected" ||
                            entry.status === "Lose"
                          ? "red"
                          : "orange",
                    }}
                  >
                    {entry.status}
                  </span>
                </div> */}

                <div style={cellStyle}>{entry.name}</div>
                <div style={cellStyle}>
                  {new Date(entry.time).toLocaleString()}
                </div>
              </div>
            ))
          ) : (
            <div
              className="noRecord"
              style={{
                padding: "7px",
                textAlign: "center",
                // border: "1px solid var(--dark-theme-white-color)",
                color: themeColors["--dark-theme-white-color"],
              }}
            >
              No records available.
            </div>
          )}
        </div>
      </div>

      {showImageModal && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction Proof</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeImageModal}
                ></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Transaction Proof"
                    className="img-fluid"
                    style={{ maxHeight: "70vh" }}
                    onError={(e) => {
                      e.target.src = "/api/placeholder/400/300";
                      e.target.alt = "Image not available";
                    }}
                  />
                ) : (
                  <div className="alert alert-warning">Image not available</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeImageModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ProfitLoss = ({ data }) => {
  const [filterType, setFilterType] = React.useState("SETTLED");
  const [startDate, setStartDate] = React.useState("");
  const [startTime, setStartTime] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);
  const [groupedData, setGroupedData] = React.useState([]);
  const [totalProfitLoss, setTotalProfitLoss] = React.useState(0);
  const { themeColors } = useTheme();

  // Initialize with the original data
  React.useEffect(() => {
    const sportData = data && data.sportData ? data.sportData : [];
    setFilteredData(sportData);
    processData(sportData);
  }, [data]);

  // Process data to group by market name and calculate profit/loss
  const processData = (sportData) => {
    // Group data by event name (market name)
    const groupedByMarket = {};
    let total = 0;

    sportData.forEach((item) => {
      if (!groupedByMarket[item.eventName]) {
        groupedByMarket[item.eventName] = {
          eventName: item.eventName,
          profitLoss: 0,
          side: item.side, // Just to preserve the side for styling
        };
      }

      // Calculate profit/loss based on status
      const amount =
        item.status === 1
          ? parseFloat(item.profit) || 0
          : item.status === 2
          ? -parseFloat(item.betAmount) || 0
          : 0;

      groupedByMarket[item.eventName].profitLoss += amount;
      total += amount;
    });

    // Convert to array for rendering
    const groupedArray = Object.values(groupedByMarket);
    setGroupedData(groupedArray);
    setTotalProfitLoss(total);
  };

  // Handle form submission
  const handleLoadReport = (e) => {
    e.preventDefault();

    const sportData = data && data.sportData ? data.sportData : [];

    // Filter the data based on dates
    const filtered = sportData.filter((item) => {
      const itemDate = new Date(item.time);

      // Create date objects for comparison
      let startDateTime = null;
      let endDateTime = null;

      if (startDate) {
        startDateTime = new Date(startDate);
        if (startTime) {
          const [hours, minutes] = startTime.split(":");
          startDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
        } else {
          startDateTime.setHours(0, 0, 0);
        }
      }

      if (endDate) {
        endDateTime = new Date(endDate);
        if (endTime) {
          const [hours, minutes] = endTime.split(":");
          endDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 59);
        } else {
          endDateTime.setHours(23, 59, 59);
        }
      }

      // Apply date filters
      let passesFilter = true;

      if (startDateTime && itemDate < startDateTime) {
        passesFilter = false;
      }

      if (endDateTime && itemDate > endDateTime) {
        passesFilter = false;
      }

      // Apply filter type if needed
      if (filterType && item.status !== filterType) {
        passesFilter = false;
      }

      return passesFilter;
    });

    setFilteredData(filtered);
    processData(filtered);
  };

  return (
    <>
      <style>{`
    .input_box::placeholder {
      color: black !important;
    }
   `}</style>
      <div className="mt-3">
        <form
          className="form-container"
          style={{
            display: "flex",
            backgroundColor: themeColors["--dark-theme-color-navbar"],
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
          onSubmit={handleLoadReport}
        >
          {/* Filter Type Dropdown */}
          <div style={{ flex: 3 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              Filter Type
            </p>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: themeColors["--dark-theme-color"],
                color: themeColors["--dark-theme-white-color"],
                border: "1px solid #128aa2",
                padding: "10px",
                borderRadius: "4px",
                appearance: "auto",
              }}
            >
              <option value="SETTLED">SETTLED</option>
              <option value="MATCHED">MATCHED</option>
              <option value="CANCEL">CANCEL</option>
              <option value="VOIDED">VOIDED</option>
              <option value="LAPSED">LAPSED</option>
              <option value="UN-MATCHED">UN-MATCHED</option>
            </select>
          </div>

          {/* Start Date & Time */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              Start Date & Time:
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  value={startDate}
                  className="input_box"
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="dd-mm-yyyy"
                  defaultValue="04-04-2025"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M11 1v3M5 1v3M2 6h12"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
              </div>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  className="input_box"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="6.5"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M8 4v4l3 2"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* End Date & Time */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              End Date & Time:
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  value={endDate}
                  className="input_box"
                  onChange={(e) => setEndDate(e.target.value)}
                  defaultValue="10-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M11 1v3M5 1v3M2 6h12"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
              </div>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  value={endTime}
                  className="input_box"
                  onChange={(e) => setEndTime(e.target.value)}
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="6.5"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M8 4v4l3 2"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, paddingTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                background: themeColors["--dark-theme-card-bg"],
                color: "#000000",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>

      <div style={{ marginTop: "-23px" }} className="ml-1 mr-2 p-2">
        <div className="p-2">Profit and Loss Statement</div>
        <table className="table-responsive-sm table-responsive-md w-100">
          <thead
            style={{
              backgroundColor: themeColors["--dark-theme-dark-blue-variant"],
            }}
          >
            <tr className="p-2">
              <th
                className="text-center text-nowrap fs-7 fw-bolder bb col-6"
                style={{ color: themeColors["--dark-theme-color-navbar"] }}
              >
                Market Name
              </th>
              <th
                className="text-center text-nowrap bb"
                style={{ color: themeColors["--dark-theme-color-navbar"] }}
              >
                Profit/Loss
              </th>
            </tr>
          </thead>

          <tbody>
            {groupedData && groupedData.length > 0 ? (
              <>
                {groupedData.map((item, index) => (
                  <tr
                    key={index}
                    className="border"
                    style={{
                      background:
                        item.side === "Back"
                          ? "linear-gradient(180deg, #f59dc2, #f5e9ee)"
                          : "linear-gradient(180deg, #84c2f1, #d9efff)",
                    }}
                  >
                    <td className="text-start text-white p-2 bb">
                      {item.eventName}
                    </td>
                    <td
                      className="text-center text-white bb"
                      style={{
                        color: item.profitLoss >= 0 ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {item.profitLoss.toFixed(2)}
                    </td>
                  </tr>
                ))}
                {/* Total row */}
                <tr
                  className="border"
                  style={{
                    background: themeColors["--dark-theme-time-remaining"],
                  }}
                >
                  <td
                    style={{ color: themeColors["--dark-theme-white-color"] }}
                    className="text-start p-2 fs-7 fw-bolder bb"
                  >
                    Total:
                  </td>
                  <td
                    className="text-center fs-7 fw-bolder bb"
                    style={{
                      color:
                        totalProfitLoss >= 0
                          ? themeColors["--dark-theme-data-min"]
                          : themeColors["--dark-theme-demoaccount"],
                    }}
                  >
                    {totalProfitLoss.toFixed(2)}
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td
                  style={{ color: themeColors["--dark-theme-white-color"] }}
                  className="text-start p-2 fs-7 fw-bolder bb"
                >
                  Total:
                </td>
                <td
                  style={{ color: themeColors["--dark-theme-white-color"] }}
                  className="text-start fs-7 fw-bolder bb"
                >
                  0.00
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

const ChangePassword = () => {
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated, changepassword, logout } = useContext(AuthContext);
  const [oldPassword, setoldPassword] = useState("");
  const [newpass, setnewpass] = useState("");
  const [confirm_pass, setconfirm_pass] = useState("");
  const [isSidebar, setSidebar] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const submitform = (e) => {
    e.preventDefault();
    let data = {
      password: oldPassword,
      newPassWord: newpass,
      RePassWord: confirm_pass,
    };
    changepassword(data, function (res) {
      console.log(res.status);
      if (res.status) {
        message(1, res.message);
        logout();
        navigate("/");
      } else {
        message(0, res.message);
      }
    });
  };

  const message = (status, text) => {
    if (status === 1) {
      toast.success(text);
    } else if (status === 0) {
      toast.error(text);
    } else if (status === 2) {
      toast.error(text);
    }
  };

  return (
    <>
      <div
        _ngcontent-hdd-c80=""
        className=""
        style={{
          height: "100vh",
          background: themeColors["--dark-theme-color-navbar"],
        }}
      >
        <div className="marquee"></div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                {/* <Layout /> */}
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-changepassword _nghost-yqq-c159="">
                    <div
                      _ngcontent-yqq-c159=""
                      className="col-md-4 p-0 mx-auto change-pass"
                      style={{
                        background: themeColors["--dark-theme-color-navbar"],
                        border: "6px solid var(--dark-theme-data-box)",
                        borderRadius: "15px",
                      }}
                    >
                      <h4
                        _ngcontent-yqq-c159=""
                        className="chnage-pass-text"
                        style={{
                          color: themeColors["--dark-theme-white-color"],
                        }}
                      >
                        Change Password
                      </h4>
                      <div
                        _ngcontent-yqq-c159=""
                        className="bg-white form-box mx-auto custom-padding"
                      >
                        <form
                          onSubmit={submitform}
                          _ngcontent-yqq-c159=""
                          noValidate=""
                          className="ng-untouched ng-pristine ng-invalid"
                        >
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Current Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span
                                  _ngcontent-vug-c116=""
                                  className="user_icon"
                                >
                                  <i
                                    _ngcontent-vug-c116=""
                                    className="bi bi-lock"
                                  ></i>
                                </span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                formcontrolname="current_pass"
                                autoFocus=""
                                onChange={(e) => setoldPassword(e.target.value)}
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Current Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="oldPassword"
                                className="floating-label"
                              >
                                Current Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">New Password</label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span
                                  _ngcontent-vug-c116=""
                                  className="user_icon"
                                >
                                  <i
                                    _ngcontent-vug-c116=""
                                    className="bi bi-lock"
                                  ></i>
                                </span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) => setnewpass(e.target.value)}
                                formcontrolname="new_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="New Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="passInput"
                                className="floating-label"
                              >
                                New Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Confirm Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span
                                  _ngcontent-vug-c116=""
                                  className="user_icon"
                                >
                                  <i
                                    _ngcontent-vug-c116=""
                                    className="bi bi-lock"
                                  ></i>
                                </span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) =>
                                  setconfirm_pass(e.target.value)
                                }
                                formcontrolname="confirm_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Confirm Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="confirmPassInput"
                                className="floating-label"
                              >
                                Confirm Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-4">
                            <button
                              _ngcontent-yqq-c159=""
                              type="submit"
                              className="login-btn"
                            >
                              {" "}
                              Change Password{" "}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </app-changepassword>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};

const Result = ({ data }) => {
  // Receive data as prop
  const { themeColors } = useTheme();
  const sportData = data && data.length > 0 ? data : [];
  // const main_balance=data & data.length>0? data:[];
  // console.log("Anshul sport data is ", sportData);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Fancy Tennis");
  const [history, setHistory] = useState([]);
  const [fancyFetchHistory, setFancyFetchHistory] = useState([]);

  const options = ["Fancy Tennis", "Cricket", "Casino"];

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const fethcHistory = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/betMatchHistory",

        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
        }
      );
      // console.log('airh',response.data);
      const hist = response.data.matchHistory;
      // console.log('jiys ghvduhguydb',hist);
      if (response?.data.success) {
        setHistory(hist);
      }

      const response2 = await axios.get(
        base_url + "/api/webapi/betFancyMatchHistory",
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
          },
        }
      );

      // console.log('API response:', response2.data);

      const hist2 = response2.data.matchHistory; // Use response2, not response
      // console.log('Fetched History:', hist2);

      if (response2.data.success) {
        setFancyFetchHistory(hist2);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fethcHistory();
    // console.log(history);
  }, []);

  //       console.log("fancy historu idwta is sih" , fancyFetchHistory)
  //       console.log("Hostory is " , history)

  // console.log(sportData,"cfghvbhjklm;")
  return (
    <>
      <style>{`
    .input_box::placeholder {
      color: black !important;
    }
   `}</style>

      <div className="mt-3 ">
        <form
          className="form-container"
          style={{
            display: "flex",
            backgroundColor: themeColors["--dark-theme-color-navbar"],
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Filter Type Dropdown */}
          {/* <div style={{flex: 3}}>
    <p style={{color: themeColors['--dark-theme-white-color'], fontSize: '14px', marginBottom: '8px'}}>Filter Type</p>
    <select style={{width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: 'none', padding: '10px', borderRadius: '4px', appearance: 'auto'}}>
      <option>SETTLED</option>
      <option>MATCHED</option>
      <option>CANCEL</option>
      <option>VOIDED</option>
      <option>LAPSED</option>
      <option>UN-MATCHED</option>
    </select>
  </div> */}
          <div style={{ flex: 2 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              {" "}
              Filter Type
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "none",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <span>{selected}</span>
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <ChevronDown
                      size={16}
                      style={{
                        color: themeColors["--dark-theme-white-color"],
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.2s ease",
                      }}
                    />
                  </span>
                </div>

                {isOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: themeColors["--dark-theme-color"],
                      borderRadius: "4px",
                      marginTop: "2px",
                      zIndex: 10,
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {options.map((option) => (
                      <div
                        key={option}
                        onClick={() => handleSelect(option)}
                        style={{
                          padding: "10px",
                          color: themeColors["--dark-theme-white-color"],
                          cursor: "pointer",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#2c2c2c";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#212121";
                        }}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Start Date & Time */}
          <div style={{ flex: 4 }}>
            <p
              style={{
                color: themeColors["--dark-theme-white-color"],
                fontSize: "14px",
                marginBottom: "8px",
              }}
            >
              {" "}
              Date & Time:
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  className="input_box"
                  defaultValue="04-04-2025"
                  placeholder="dd-mm-yyyy"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M11 1v3M5 1v3M2 6h12"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
              </div>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: themeColors["--dark-theme-color"],
                    color: themeColors["--dark-theme-white-color"],
                    border: "1px solid #128aa2",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="8"
                      cy="8"
                      r="6.5"
                      stroke="white"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M8 4v4l3 2"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          {/* End Date & Time */}
          {/* <div style={{flex: 3.5}}>
    <p style={{color: themeColors['--dark-theme-white-color'], fontSize: '14px', marginBottom: '8px'}}>End Date & Time:</p>
    <div style={{display: 'flex', gap: '10px'}}>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="10-04-2025"
          placeholder="dd-mm-yyyy"
          style={{width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: 'none', padding: '10px', borderRadius: '4px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3h10c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1z" stroke="white" strokeWidth="1.5"/>
            <path d="M11 1v3M5 1v3M2 6h12" stroke="white" strokeWidth="1.5"/>
          </svg>
        </span>
      </div>
      <div style={{position: 'relative', flex: 1}}>
        <input
          type="text"
          defaultValue="10:48:21"
          style={{width: '100%', backgroundColor: themeColors['--dark-theme-color'], color: themeColors['--dark-theme-white-color'], border: 'none', padding: '10px', borderRadius: '4px', paddingRight: '30px'}}
        />
        <span style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)'}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6.5" stroke="white" strokeWidth="1.5"/>
            <path d="M8 4v4l3 2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </span>
      </div>
    </div>
  </div> */}

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              style={{
                width: "100%",
                background: themeColors["--dark-theme-card-bg"],
                color: "#000000",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>
      <table className="table-responsive-sm table-responsive-md w-100 bg-black">
        <thead
          style={{
            backgroundColor: themeColors["--dark-theme-dark-blue-variant"],
          }}
        >
          <tr className="p-2 bb" style={{ height: "40px" }}>
            <th
              className="text-start text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Competition Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Event Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Market Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: themeColors["--dark-theme-color-navbar"] }}
            >
              Results
            </th>
          </tr>
        </thead>
        <tbody>
          {history && history.length > 0
            ? history.map((ele, index) => {
                const match = ele.match?.[0]; // safely get the first match
                return (
                  <tr
                    key={`match-${index}`}
                    className="border"
                    style={{
                      background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                      height: "40px",
                    }}
                  >
                    <td className="text-start text-nowrap bb">
                      {match?.competitionname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.eventname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.marketname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.result ? match.result : "Pending"}
                    </td>
                  </tr>
                );
              })
            : null}

          {fancyFetchHistory && fancyFetchHistory.length > 0
            ? fancyFetchHistory.map((ele, index) => (
                <tr
                  key={`fancy-${index}`}
                  className="border"
                  style={{
                    background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                    height: "40px",
                  }}
                >
                  <td className="text-start text-nowrap bb">
                    {ele.competitionName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.eventName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.runnerName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.result || "Pending"}
                  </td>
                </tr>
              ))
            : null}

          {history.length === 0 && fancyFetchHistory.length === 0 && (
            <tr>
              <td
                colSpan="4"
                className="text-center"
                style={{ color: themeColors["--dark-theme-color-navbar"] }}
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default SportsBets;